// All classes in thid file are automatically added to a global
// _site variable, so can be accessed anywhere without having to
// do an import etc..
// e.g. _site.AlertHelper.showErrorAlert("message",e)

import { blockUI, unblockUI } from 'jquery';
import Swal from 'sweetalert2';
import swal from 'sweetalert2';
export class Base64Helper {
    public static coerceToArrayBuffer(thing:any, name:any) {
        if (typeof thing === "string") {
            // base64url to base64
            thing = thing.replace(/-/g, "+").replace(/_/g, "/");

            // base64 to Uint8Array
            const str = window.atob(thing);
            const bytes = new Uint8Array(str.length);
            for (let i = 0; i < str.length; i++) {
                bytes[i] = str.charCodeAt(i);
            }
            thing = bytes;
        }

        // Array to Uint8Array
        if (Array.isArray(thing)) {
            thing = new Uint8Array(thing);
        }

        // Uint8Array to ArrayBuffer
        if (thing instanceof Uint8Array) {
            thing = thing.buffer;
        }

        // error if none of the above worked
        if (!(thing instanceof ArrayBuffer)) {
            throw new TypeError("could not coerce '" + name + "' to ArrayBuffer");
        }

        return thing;
    };


    public static coerceToBase64Url(thing: any) {
        // Array or ArrayBuffer to Uint8Array
        if (Array.isArray(thing)) {
            thing = Uint8Array.from(thing);
        }

        if (thing instanceof ArrayBuffer) {
            thing = new Uint8Array(thing);
        }

        // Uint8Array to base64
        if (thing instanceof Uint8Array) {
            let str = "";
            const len = thing.byteLength;

            for (let i = 0; i < len; i++) {
                str += String.fromCharCode(thing[i]);
            }
            thing = window.btoa(str);
        }

        if (typeof thing !== "string") {
            throw new Error("could not coerce to string");
        }

        // base64 to base64url
        // NOTE: "=" at the end of challenge is optional, strip it off here
        thing = thing.replace(/\+/g, "-").replace(/\//g, "_").replace(/=*$/g, "");

        return thing;
    };
}


export class AlertHelper {

    public static showErrorAlert(message:string, error:any) {
        let footermsg = '';
        if (error) {
            footermsg = 'exception:' + error.toString();
        }
        swal.fire({
         //   type: 'error',
            title: 'Error',
            text: message,
            footer: footermsg
            //footer: '<a href>Why do I have this issue?</a>'
        })
    }

}

export class FIDOHelper {
    public static detectFIDOSupport() {
        if (window.PublicKeyCredential === undefined ||
            typeof window.PublicKeyCredential !== "function") {
            //$('#register-button').attr("disabled", true);
            //$('#login-button').attr("disabled", true);
            const el = document.getElementById("notSupportedWarning");
            if (el) {
                el.style.display = 'block';
            }
            return;
        }
    }
}

export class FormHelper
{
    /**
 * 
 * Get a form value
 * @param {any} selector
 */
    public static value(selector:string):any {
        let el:any = document.querySelector(selector);
        if (el.type === "checkbox") {
            return el.checked;
        }
        return el.value;
    }

  
}

export class PreLoadHelper {
    private preloaderHideClass = 'preloader-hide';

    public showPreLoader(timeoutMs: number, ontimeout?: Function) {
        const preloader = $('#preloader');

        if (preloader) {
            preloader.removeClass(this.preloaderHideClass);
            setTimeout(() => {
                preloader.addClass(this.preloaderHideClass);
                if (typeof ontimeout !== "undefined") ontimeout();
            }, timeoutMs);
        }
    }
}

export class BlockPageHelper {
    public static block() {
        if (typeof blockUI !== "undefined") blockUI({ message: "<div id='ajaxLoader' class='spinner-border'></div>", css: { border: '0px 0px 0px 0px,', width: 0, height: 0, top: '50%', left: '50%' } });
    }

    public static unblock() {
        if (typeof unblockUI !== "undefined") unblockUI();
    }
}

export class ScriptHelper {
    public static stripScripts(s: string) {
        const div = document.createElement('div');
        div.innerHTML = s;
        const scripts = div.getElementsByTagName('script');
        let i = scripts.length;

        while (i--) {
            if (scripts[i] !== null) {
                const currentScript = scripts[i];
                if (currentScript.parentNode !== null) {
                    currentScript.parentNode.removeChild(currentScript);
                }
            }
        }
        return div.innerHTML;
    }
}

export class SwalHelper {
    public static InitSwalDescriptionViewer(popupContainer: string, hostContainer: string) {
        const title = $(popupContainer).find(".swalTitle label")[0].innerText;
        const html = $(popupContainer).find(".swalText")[0].innerHTML;
        Swal.fire({
            showCloseButton: true,
            showConfirmButton: false,
          /*  customClass: { container: 'descriptionPopup' },*/
            title: title,
            grow: false,
            html: ScriptHelper.stripScripts(html),
            target:hostContainer
        })
    }
}